import type { QueryClient } from "@tanstack/react-query";

/**
 * Invalide les requêtes `GET` posées sur les chemins d'API donnés.
 *
 * ## Pourquoi il faut les énumérer, et pas se fier à un préfixe
 *
 * La clé d'`openapi-react-query` est `[méthode, chemin, init]`, et React Query
 * la compare **élément par élément**. Omettre le troisième segment est donc
 * légitime — c'est ce qui atteint d'un coup toutes les pages d'une liste, quel
 * que soit son filtre —, mais le **chemin**, lui, est comparé en entier : ce
 * n'est pas un préfixe de chaîne.
 *
 * `["get", "/…/accounts"]` ne touche donc **que** la liste. La fiche vit sous
 * `/…/accounts/{id}`, une autre chaîne : elle n'était jamais invalidée, et
 * l'écran depuis lequel on venait de désactiver un compte ou de poser un
 * drapeau continuait d'afficher l'état d'avant l'action.
 *
 * D'où cet helper : une action de modération nomme les chemins qu'elle change,
 * la liste **et** la fiche.
 */
export function invalidateApiPaths(client: QueryClient, paths: string[]) {
  return Promise.all(
    paths.map((path) => client.invalidateQueries({ queryKey: ["get", path] })),
  );
}
